/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the team formation
 * @export
 */
export const TeamFormationStatus = {
    FORMING: 'FORMING',
    READY: 'READY',
    REGISTERED: 'REGISTERED',
    ACTIVE: 'ACTIVE',
    DISBANDED: 'DISBANDED'
} as const;
export type TeamFormationStatus = typeof TeamFormationStatus[keyof typeof TeamFormationStatus];


export function instanceOfTeamFormationStatus(value: any): boolean {
    for (const key in TeamFormationStatus) {
        if (Object.prototype.hasOwnProperty.call(TeamFormationStatus, key)) {
            if (TeamFormationStatus[key as keyof typeof TeamFormationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamFormationStatusFromJSON(json: any): TeamFormationStatus {
    return TeamFormationStatusFromJSONTyped(json, false);
}

export function TeamFormationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamFormationStatus {
    return json as TeamFormationStatus;
}

export function TeamFormationStatusToJSON(value?: TeamFormationStatus | null): any {
    return value as any;
}

export function TeamFormationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TeamFormationStatus {
    return value as TeamFormationStatus;
}

